<template>
  <div class="singlePost">
    <BreadsCrums page="article" previous="home" />
    <section class="blog-v3 garden-set-pd-sm-lg" v-if="!loading">
      <div class="container">
        <div class="row">
          <div class="col-md-8 article">
            <div class="box">
              <div class="garden-img-full-width garden-overlay-scale">
                <img v-if="post.featuredImage" :src="post.featuredImage" alt />
                <img v-else :src="post.image" alt />
              </div>
              <h6>{{ postType }}</h6>
              <div class="meta">
                <ul>
                  <li>
                    <p v-if="post.chargerDuProjet">
                      <span class="fa fa-user"></span>
                      {{ post.chargerDuProjet }}
                    </p>
                    <p v-else>
                      <span class="fa fa-user"></span>
                      Afrik Eveil
                    </p>
                  </li>
                  <li>
                    <p>
                      <span class="fa fa-calendar"></span>
                      {{ format_date(post.created_at) }}
                    </p>
                  </li>
                  <li>
                    <p>
                      <span class="fa fa-clock-o"></span>
                      <timeago
                        :datetime="post.created_at"
                        :locale="locale"
                      ></timeago>
                    </p>
                  </li>
                </ul>
              </div>
              <h3 class="title">{{ post.title }}</h3>
              <div class="content" v-html="this.$sanitize(post.content)"></div>
              <div class="content" v-if="post.attachment">
                <br />
                <a :href="post.attachment" target="_blank">
                  {{ post.attachmentName }}
                </a>
              </div>
              <div class="share">
                <h2 class="text-center">Share this post</h2>
                <Facebook
                  :url="url"
                  :title="post.title"
                  scale="3"
                  class="icon"
                />
                <Twitter
                  :url="url"
                  :title="post.title"
                  scale="3"
                  class="icon"
                />
                <Linkedin
                  :url="url"
                  :title="post.title"
                  scale="3"
                  class="icon"
                />
                <WhatsApp
                  :url="url"
                  :title="post.title"
                  scale="3"
                  class="icon"
                />
                <Google :url="url" :title="post.title" scale="3" class="icon" />
                <Email
                  :url="url"
                  :subject="post.title"
                  scale="3"
                  class="icon"
                />
              </div>
              <div class="comments">
                <vue-disqus
                  shortname="http-188-226-149-64-afrikeveil"
                  :identifier="post.slug"
                  :url="url"
                ></vue-disqus>
              </div>
            </div>
          </div>
          <SideBar :categories="categories" :tags="tags" />
        </div>
      </div>
    </section>
    <Loader v-else />
  </div>
</template>

<script>
import Axios from 'axios';
import moment from 'moment';
import APPURL from '../constant';
export default {
  watch: {
    $route() {
      this.getLang();
      this.format_date();
    }
  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    //document.title = this.$i18n.t("navBar.home");
  },
  mounted() {
    this.getPostBySlug();
    this.getLang();
    this.getTags();
    this.getCategories();
  },
  data() {
    return {
      post: {},
      category: {},
      categories: {},
      tags: {},
      locale: '',
      type: '',
      loading: true,
      url: window.location.href
    };
  },
  metaInfo() {
    //console.log(this.post.content);
   // console.log(this.$sanitize(this.post.content));
    return {
      title: this.post.title,
      meta: [
        {
          vmid: 'og:description',
          name: 'description',
          property: 'og:description',
          content: 'Wow'
        },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'description', content: this.post.title },
        { property: 'og:site_name', content: 'Afrik Eveil' },
        { property: 'fb:app_id', content: '400025927061215' },
        { property: 'og:title', content: this.post.title },
        { property: 'og:description', content: this.post.title },
        {
          property: 'og:image',
          content: this.post.featuredImage
            ? this.post.featuredImage
            : this.post.image
        },
        { property: 'og:type', content: 'article' },
        { property: 'og:url', content: window.location.href },
        { property: 'twitter:card', content: 'summary' },
        { property: 'twitter:site', content: '@afrikeveil' },
        { property: 'twitter:title', content: this.post.title },
        { property: 'twitter:description', content: this.post.title },
        {
          property: 'twitter:image',
          content: this.post.featuredImage
            ? this.post.featuredImage
            : this.post.image
        }
      ]
    };
  },
  methods: {
    getPostBySlug() {
      var slug = `${this.$route.params.slug}`;
      // console.log(this.$route.params.type);
      var request = '';
      if (this.$route.params.type == 'project') {
        request = APPURL.LINK + 'project-by-slug/' + slug;
        //console.log("slug is " + slug);
        Axios.get(request).then(response => {
          this.loading = false;
          this.post = response.data.data.results[0];
          this.category = response.data.data.results.category;
          // console.log(this.loading);
        });
      } else if (this.$route.params.type == 'covid') {
        request = APPURL.LINK + 'covid-by-slug/' + slug;
        //console.log("slug is " + slug);
        Axios.get(request).then(response => {
          this.loading = false;
          this.post = response.data.data.results[0];
          this.category = response.data.data.results.category;
          // console.log(this.loading);
        });
      } else {
        request = APPURL.LINK + 'post-by-slug/' + slug;
        //console.log("slug is " + slug);
        Axios.get(request).then(response => {
          this.loading = false;
          this.post = response.data.data.results.post;
          this.category = response.data.data.results.category;
          // console.log(this.loading);
        });
      }
    },
    getTags() {
      Axios.get(APPURL.LINK + 'tags').then(response => {
        this.tags = response.data.data.results;
        // console.log(tags);
      });
    },
    getCategories() {
      Axios.get(APPURL.LINK + 'categories').then(response => {
        this.categories = response.data.data.results;
        //console.log(tags);
      });
    },
    getLang() {
      this.locale = this.$i18n.locale;
    },
    format_date(value) {
      if (value) {
        if (this.$i18n.locale == 'en') {
          return moment(String(value)).format('MM/DD/YYYY');
        } else {
          return moment(String(value)).format('DD/MM/YYYY');
        }
      }
    }
  },
  name: 'SinglePost',
  props: {
    postType: String
  }
};
</script>
<style scoped>
@media (min-width: 1200px) {
  /* .article {
    width: 66% !important;
  } */
  .container {
    margin: 50px !important;
    /* border: 2px solid red; */
    width: 95% !important;
  }
}

/* border: 1px solid#8ac799; */
.blog-v3 .box h3 {
  font-size: 20px !important;
  line-height: 30px;
}
.blog .box .content p,
.blog-v3 .box .content p {
  color: red !important;
  font-size: 20px !important;
}
.container1 {
  margin: 50px;
}
.share > span {
  padding: 4em;
}
.share,
.comments {
  margin-top: 30px;
  box-shadow: 0 0 54px rgba(0, 0, 0, 0.11);
  padding: 20px;
  text-align: justify;
  border-radius: 20px;
}

.share h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  text-transform: capitalize;
}

.blog-v3 {
  margin-top: -60px !important;
}
.title {
  text-align: center;
  color: #228c4f !important;
  font-weight: bolder;
}
.garden-img-full-width img {
  border-radius: 20px;
}
.box {
  border-left: 1px solid #228c4f;
  border-style: dashed;
  box-shadow: 0 0 54px rgba(0, 0, 0, 0.11);
  padding: 20px;
  text-align: justify;
  border-radius: 20px;
}

.meta {
  border: 1px dashed #228c4f;
  border-radius: 33px;
  padding-left: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.meta li {
  display: inline-block;
  padding-left: 156px;
  margin-bottom: 0px !important;
}
.meta li p {
  text-align: center;
  font-size: 12px;
  color: #4e5453 !important;
  font-weight: 400;
}
.meta li p span {
  padding-right: 7px;
  color: #228c4f;
}
@media (min-device-width: 1025px) {
  .garden-img-full-width img,
  .garden-img-full-width {
    height: 500px;
    width: 100%;
    object-fit: cover;
    object-position: 100% 0%;
  }
}

@media (min-device-width: 320px) and (max-device-width: 480px) {
  .meta {
    border: 1px dashed #228c4f;
    border-radius: 33px;
    padding-left: 20px;
    margin-top: 10px;
    margin-left: -5px;
    margin-right: -5px;
    margin-bottom: 15px;
  }
  .blog-v3 .box h3 {
    font-size: 14px;
  }
  .meta li p {
    font-size: 10px;
  }
  .meta li {
    display: inline-block;
    padding-left: 6px;
    margin-bottom: 0px !important;
  }
}
@media (max-device-width: 320px) {
  .meta {
    border: 1px dashed #228c4f;
    border-radius: 33px;
    padding-left: 1px;
    margin-top: 10px;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 15px;
  }
  .blog-v3 .box h3 {
    font-size: 13px;
  }
  .meta li p {
    font-size: 9px;
  }
  .meta li {
    display: inline-block;
    padding-left: 6px;
    margin-bottom: 0px !important;
  }
}
@media screen and (max-width: 639px) {
  .share > span {
    padding: 10px !important;
  }
}
</style>
